<template>
	<TemplateBase :is-sales="isSales">
		<div class="bg-gradient-to-r from-purple-700 to-purple-900">
			<OrganismSlideshow
				:slides
				:background-image
				:background-video
			/>
			<div class="h-28 w-full bg-gradient-to-r from-gray-100 to-gray-200">
				<div
					class="container h-full flex items-center justify-end font-display font-bold uppercase text-title-size-lg gap-4"
				>
					<AtomFontAwesome
						icon="fa-location-dot"
						class="w-8 h-8 text-gray-600"
					/>
					<span class="text-gray-800">
						{{ streetName }} {{ streetNumber }} - {{ city }}
					</span>
				</div>
			</div>
		</div>
		<slot />
	</TemplateBase>
</template>

<script lang="ts" setup>
import { city, streetName, streetNumber } from '#base/core/consts/companyData';
import type { ImageType } from '#base/core/types/ImageType';
import type { SlideType } from '#base/core/types/SlideType';
import type { VideoType } from '#base/core/types/VideoType';

defineProps<{
	slides: SlideType[];
	backgroundImage?: ImageType;
	backgroundVideo?: VideoType;
	isSales?: boolean;
}>();
</script>
